import type { TextPart as TextPartSchema } from "@acto/genui-components-schema";
// Reuses v1's markdown renderer to close the product gap on v2.1 markdown
// fallback. Same shortcut taken for chat. Replace when the v2 design system
// owns its own renderer.
import { MarkdownRenderer } from "@acto/taskpane/core/components/markdown/MarkdownRenderer";

interface TextPartProps {
  part: TextPartSchema;
}

export function TextPart({ part }: TextPartProps) {
  return <MarkdownRenderer content={part.text} />;
}
